var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2746_39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 22.501C1 21.1202 2.11929 20.001 3.5 20.001H6.83333C8.21408 20.001 9.33333 21.1202 9.33333 22.501V27.501C9.33333 28.8817 8.21408 30.001 6.83333 30.001H3.5C2.11929 30.001 1 28.8817 1 27.501V22.501Z",
    fill: "#7CE299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 12.5C11 11.1192 12.1193 10 13.5 10H16.8333C18.2141 10 19.3333 11.1192 19.3333 12.5V27.5C19.3333 28.8808 18.2141 30 16.8333 30H13.5C12.1193 30 11 28.8808 11 27.5V12.5Z",
    fill: "#7CE299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 2.5C21 1.11925 22.1193 0 23.5 0H26.8333C28.2141 0 29.3333 1.11925 29.3333 2.5V27.5C29.3333 28.8808 28.2141 30 26.8333 30H23.5C22.1193 30 21 28.8808 21 27.5V2.5Z",
    fill: "#7CE299"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2746_39"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "res/media/ok.1ecab13e1aca65462f908393b0fe8ce8.svg";
export { ForwardRef as ReactComponent };